/**
 * Strips HTML tags from a string and converts HTML entities to their text equivalents
 * @param htmlString - The HTML string to strip tags from
 * @returns Plain text string with HTML tags removed and entities decoded
 */
export function stripHtmlTags(htmlString?: string | null): string {
  if (!htmlString) return '';
  
  // Replace common HTML entities
  let text = htmlString
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&hellip;/g, '...')
    .replace(/&ndash;/g, '–')
    .replace(/&mdash;/g, '—');
  
  // Handle numbered HTML entities like &#39;
  text = text.replace(/&#(\d+);/g, (match: string, dec: string) => {
    return String.fromCharCode(parseInt(dec, 10));
  });
  
  // Handle hex HTML entities like &#x27;
  text = text.replace(/&#x([0-9a-fA-F]+);/g, (match: string, hex: string) => {
    return String.fromCharCode(parseInt(hex, 16));
  });
  
  // Remove HTML tags while preserving line breaks
  text = text
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<div[^>]*>/gi, '')
    .replace(/<\/div>/gi, '\n')
    .replace(/<[^>]*>/g, '') // Remove all other HTML tags
    .replace(/\n\s*\n/g, '\n\n') // Clean up multiple line breaks
    .trim();
  
  return text;
}
